import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ArchiveIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "14.006"}
      viewBox="0 0 14 14.006"
    >
      <g id="Archive" transform="translate(-2.002 -1.996)">
        <path
          id="Archive-2"
          data-name="Archive"
          d="M5936.1,22850a1.506,1.506,0,0,1-1.4-1.4v-7.912a1.412,1.412,0,0,1-.7-1.18v-2.109a1.453,1.453,0,0,1,1.4-1.4h11.2a1.453,1.453,0,0,1,1.4,1.4v2.109a1.411,1.411,0,0,1-.7,1.18v7.912a1.506,1.506,0,0,1-1.4,1.4Zm0-1.4h9.8v-7.7h-9.8Zm-.7-9.1h11.2v-2.1h-11.2Zm3.5,4.9v-1.4h4.2v1.4Z"
          transform="translate(-5932 -22834)"
          fill={color || "#bbb"}
        />
      </g>
    </svg>
  );
}
